import React from 'react';
import { Button, Select, Row, Col, InputNumber } from 'antd';
import { withoutId } from '../../utils/data.js';

const { Option } = Select;

function AccountBasedProRataSplitSubMenu(props) {  
  let func = props.row.func;
  let isCompound = false;
  if (props.compoundIndex !== undefined && props.compoundIndex !== null) {
    func = func.functions[props.compoundIndex];
    isCompound = true;
  }

  const model = props.model;

  function ok() {
    props.setMenuVisible(true);
    props.setAccountProRataVisible(false);    
  }

  function back() {
    props.setMenuVisible(true);
    props.setAccountProRataVisible(false);
  }

  function updateSplits(f) {        
    let newSplitState = '';
    
    if (isCompound) {
      const compoundClone = props.row.func.clone(props.row.func.id, props.row.func.target);
      compoundClone.updated = true;
      compoundClone.functions[props.compoundIndex] = f;
      newSplitState = compoundClone.getSplit();
    } else {
      f.updated = true;
      newSplitState = f.getSplit();
    }

    const newSplits = [...withoutId(model.splitState, newSplitState.id), newSplitState];
    props.setSplitsState(newSplits);  
  }

  function renderReapOrXeroAccountPicker(division) {    
    const handleChange = (value) => {    
      const f = func.clone(func.id, func.target);      
      f[division].accountType = value;
      updateSplits(f);                  
    };
  
    return (
      <Select
        style={{ width: 250 }}
        placeholder="Account Type"
        onChange={handleChange}
        value={func[division].accountType}>
        <Option value="reap">REAP Account</Option>
        <Option value="xero">XERO Account</Option>
      </Select>
    );    
  }

  function renderAccountList(division) {

    const handleChange = (value) => {  
      const f = func.clone(func.id, func.target);
      f[division].target = value;

      updateSplits(f);
    }
         
    const reapOptions = () => model.reapAccounts.map(a => {
      return <Option key={a.id} value={a.id} label={a.name}>{a.name}</Option>
    })

    const xeroOptions = () => model.xeroAccounts.map(a => {
      return <Option key={a.id} value={a.id} label={a.name}>{a.name}</Option>
    })

    const options = func[division].accountType === 'reap' ? reapOptions() : xeroOptions();
    
    return (      
      <Select
        showSearch
        style={{ width: 250 }}        
        onChange={handleChange}        
        optionFilterProp="children"
        value={func[division].target}
        filterOption={(input, option) => {
          return option.label.toLowerCase().includes(input.toLowerCase());
        }}>          
        <Option key="none" value="none" label="None">None</Option>
        {options}
      </Select>
    );
  }

  function renderAccountDivision(division) {    
    const handleChange = (value) => {
      const f = func.clone(func.id, func.target);
      f[division].division = value;

      updateSplits(f);            
    };
  
    return (
      <Select
        style={{ width: 250 }}
        placeholder="Division"
        onChange={handleChange}
        value={func[division].division}
      >
        <Option value="amount">Total</Option>
        <Option value="sales">Sales</Option>
        <Option value="pm">PM</Option>
        <Option value="dir">Dir</Option>
      </Select>
    );    
  }

  function renderCurrencyValue(division) {
    if (func[division].target === 'none') {
      return (<InputNumber value={0} readOnly style={{ width: 250 }} />);
    }
    
    const targetResult = model.results.find(a => a.accountId === func[division].target);    
    const value = targetResult[func[division].division].toFixed(2);
    return (<InputNumber value={value} readOnly style={{ width: 250 }} />);    
  }

  function getProRataTargetValue(target, division) {
    if (target === 'none') {
      return 0;
    }    

    const value = model.results.find(r => r.accountId === target)[division];
    return value;
  }

  function renderRatio(division) {
    if (func[division].target === 'none') {
      return (<InputNumber value={0} readOnly style={{ width: 250 }} />);
    }

    const sales = getProRataTargetValue(func['sales'].target, func['sales'].division);
    const pm = getProRataTargetValue(func['pm'].target, func['pm'].division);
    const dir = getProRataTargetValue(func['dir'].target, func['dir'].division);    

    const thisDivision = getProRataTargetValue(func[division].target, func[division].division);    

    const totalValue = sales + pm + dir;

    const ratio = thisDivision / totalValue;

    return (<InputNumber value={ratio.toFixed(2)} readOnly style={{ width: 250 }} />);    
  }

  return (
    <div>
      <div style={{ height: 280 }}>
        
        <Row>
          <Col span={8}><strong>Sales</strong></Col>
          <Col span={8}><strong>PM</strong></Col>
          <Col span={8}><strong>Dir</strong></Col>
        </Row>

        <Row style={{ marginTop: 10, marginLeft: -5 }}>
          <Col span={8}>{renderReapOrXeroAccountPicker('sales')}</Col>
          <Col span={8}>{renderReapOrXeroAccountPicker('pm')}</Col>
          <Col span={8}>{renderReapOrXeroAccountPicker('dir')}</Col>
        </Row>

        <Row style={{ marginTop: 10, marginLeft: -5 }}>          
          <Col span={8}>{renderAccountList('sales')}</Col>
          <Col span={8}>{renderAccountList('pm')}</Col>
          <Col span={8}>{renderAccountList('dir')}</Col>
        </Row>        

        <Row style={{ marginTop: 10, marginLeft: -5 }}>          
          <Col span={8}>{renderAccountDivision('sales')}</Col>
          <Col span={8}>{renderAccountDivision('pm')}</Col>
          <Col span={8}>{renderAccountDivision('dir')}</Col>
        </Row>

        <Row style={{ marginTop: 10, marginLeft: -5 }}>          
          <Col span={8}>{renderCurrencyValue('sales')}</Col>
          <Col span={8}>{renderCurrencyValue('pm')}</Col>
          <Col span={8}>{renderCurrencyValue('dir')}</Col>
        </Row>

        <Row style={{ marginTop: 10, marginLeft: -5 }}>          
          <Col span={8}>{renderRatio('sales')}</Col>
          <Col span={8}>{renderRatio('pm')}</Col>
          <Col span={8}>{renderRatio('dir')}</Col>
        </Row>        

        <Row style={{ marginTop: 10 }}>          
        </Row>
        <Row style={{ marginTop: 10 }}>          
        </Row>
      </div>
      <Button type="default"
        style={{
          marginTop: '20px',
          float: 'right',
          marginRight: '10px'
        }}
        onClick={back}>Back</Button>
      <Button type="primary"
        style={{
          marginTop: '20px',
          float: 'right',
          marginRight: '10px'
        }}
        onClick={ok}>OK</Button>
    </div>
  );
}

export default AccountBasedProRataSplitSubMenu;
